/*
 * bpmbuild-development.appspot.com
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.11-SNAPSHOT
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/Axis', 'model/ChartArea'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./Axis'), require('./ChartArea'));
  } else {
    // Browser globals (root is window)
    if (!root.BpmbuildDevelopmentappspotcom) {
      root.BpmbuildDevelopmentappspotcom = {};
    }
    root.BpmbuildDevelopmentappspotcom.GoogleChartOptionsRequest = factory(root.BpmbuildDevelopmentappspotcom.ApiClient, root.BpmbuildDevelopmentappspotcom.Axis, root.BpmbuildDevelopmentappspotcom.ChartArea);
  }
}(this, function(ApiClient, Axis, ChartArea) {
  'use strict';

  /**
   * The GoogleChartOptionsRequest model module.
   * @module model/GoogleChartOptionsRequest
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>GoogleChartOptionsRequest</code>.
   * @alias module:model/GoogleChartOptionsRequest
   * @class
   */
  var exports = function() {
  };

  /**
   * Constructs a <code>GoogleChartOptionsRequest</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/GoogleChartOptionsRequest} obj Optional instance to populate.
   * @return {module:model/GoogleChartOptionsRequest} The populated <code>GoogleChartOptionsRequest</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();
      if (data.hasOwnProperty('allowHtml'))
        obj.allowHtml = ApiClient.convertToType(data['allowHtml'], 'Boolean');
      if (data.hasOwnProperty('backgroundColor'))
        obj.backgroundColor = ApiClient.convertToType(data['backgroundColor'], 'String');
      if (data.hasOwnProperty('barGroupWidth'))
        obj.barGroupWidth = ApiClient.convertToType(data['barGroupWidth'], 'String');
      if (data.hasOwnProperty('bubble'))
        obj.bubble = ApiClient.convertToType(data['bubble'], 'String');
      if (data.hasOwnProperty('candlestick'))
        obj.candlestick = ApiClient.convertToType(data['candlestick'], 'String');
      if (data.hasOwnProperty('chartArea'))
        obj.chartArea = ChartArea.constructFromObject(data['chartArea']);
      if (data.hasOwnProperty('codeTag'))
        obj.codeTag = ApiClient.convertToType(data['codeTag'], 'String');
      if (data.hasOwnProperty('curveType'))
        obj.curveType = ApiClient.convertToType(data['curveType'], 'String');
      if (data.hasOwnProperty('dateCreated'))
        obj.dateCreated = ApiClient.convertToType(data['dateCreated'], 'Date');
      if (data.hasOwnProperty('fontColor'))
        obj.fontColor = ApiClient.convertToType(data['fontColor'], 'String');
      if (data.hasOwnProperty('greenFrom'))
        obj.greenFrom = ApiClient.convertToType(data['greenFrom'], 'Number');
      if (data.hasOwnProperty('greenTo'))
        obj.greenTo = ApiClient.convertToType(data['greenTo'], 'Number');
      if (data.hasOwnProperty('hAxis'))
        obj.hAxis = Axis.constructFromObject(data['hAxis']);
      if (data.hasOwnProperty('haxis'))
        obj.haxis = Axis.constructFromObject(data['haxis']);
      if (data.hasOwnProperty('headerHeight'))
        obj.headerHeight = ApiClient.convertToType(data['headerHeight'], 'Number');
      if (data.hasOwnProperty('height'))
        obj.height = ApiClient.convertToType(data['height'], 'Number');
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
      if (data.hasOwnProperty('is3D'))
        obj.is3D = ApiClient.convertToType(data['is3D'], 'Boolean');
      if (data.hasOwnProperty('isStacked'))
        obj.isStacked = ApiClient.convertToType(data['isStacked'], 'Boolean');
      if (data.hasOwnProperty('lastUpdatedDateTime'))
        obj.lastUpdatedDateTime = ApiClient.convertToType(data['lastUpdatedDateTime'], 'Date');
      if (data.hasOwnProperty('legend'))
        obj.legend = ApiClient.convertToType(data['legend'], 'String');
      if (data.hasOwnProperty('maxColor'))
        obj.maxColor = ApiClient.convertToType(data['maxColor'], 'String');
      if (data.hasOwnProperty('midColor'))
        obj.midColor = ApiClient.convertToType(data['midColor'], 'String');
      if (data.hasOwnProperty('minColor'))
        obj.minColor = ApiClient.convertToType(data['minColor'], 'String');
      if (data.hasOwnProperty('minorTricks'))
        obj.minorTricks = ApiClient.convertToType(data['minorTricks'], 'Number');
      if (data.hasOwnProperty('name'))
        obj.name = ApiClient.convertToType(data['name'], 'String');
      if (data.hasOwnProperty('pieHole'))
        obj.pieHole = ApiClient.convertToType(data['pieHole'], 'Number');
      if (data.hasOwnProperty('redFrom'))
        obj.redFrom = ApiClient.convertToType(data['redFrom'], 'Number');
      if (data.hasOwnProperty('redTo'))
        obj.redTo = ApiClient.convertToType(data['redTo'], 'Number');
      if (data.hasOwnProperty('showInfoWindow'))
        obj.showInfoWindow = ApiClient.convertToType(data['showInfoWindow'], 'Boolean');
      if (data.hasOwnProperty('showScale'))
        obj.showScale = ApiClient.convertToType(data['showScale'], 'Boolean');
      if (data.hasOwnProperty('showTooltip'))
        obj.showTooltip = ApiClient.convertToType(data['showTooltip'], 'Boolean');
      if (data.hasOwnProperty('title'))
        obj.title = ApiClient.convertToType(data['title'], 'String');
      if (data.hasOwnProperty('userId'))
        obj.userId = ApiClient.convertToType(data['userId'], 'String');
      if (data.hasOwnProperty('vAxis'))
        obj.vAxis = Axis.constructFromObject(data['vAxis']);
      if (data.hasOwnProperty('vaxis'))
        obj.vaxis = Axis.constructFromObject(data['vaxis']);
      if (data.hasOwnProperty('width'))
        obj.width = ApiClient.convertToType(data['width'], 'Number');
      if (data.hasOwnProperty('wordtreeFormat'))
        obj.wordtreeFormat = ApiClient.convertToType(data['wordtreeFormat'], 'String');
      if (data.hasOwnProperty('wordtreeWord'))
        obj.wordtreeWord = ApiClient.convertToType(data['wordtreeWord'], 'String');
      if (data.hasOwnProperty('yellowFrom'))
        obj.yellowFrom = ApiClient.convertToType(data['yellowFrom'], 'Number');
      if (data.hasOwnProperty('yellowTo'))
        obj.yellowTo = ApiClient.convertToType(data['yellowTo'], 'Number');
    }
    return obj;
  }

  /**
   * @member {Boolean} allowHtml
   */
  exports.prototype.allowHtml = undefined;

  /**
   * @member {String} backgroundColor
   */
  exports.prototype.backgroundColor = undefined;

  /**
   * @member {String} barGroupWidth
   */
  exports.prototype.barGroupWidth = undefined;

  /**
   * @member {String} bubble
   */
  exports.prototype.bubble = undefined;

  /**
   * @member {String} candlestick
   */
  exports.prototype.candlestick = undefined;

  /**
   * @member {module:model/ChartArea} chartArea
   */
  exports.prototype.chartArea = undefined;

  /**
   * @member {String} codeTag
   */
  exports.prototype.codeTag = undefined;

  /**
   * @member {String} curveType
   */
  exports.prototype.curveType = undefined;

  /**
   * @member {Date} dateCreated
   */
  exports.prototype.dateCreated = undefined;

  /**
   * @member {String} fontColor
   */
  exports.prototype.fontColor = undefined;

  /**
   * @member {Number} greenFrom
   */
  exports.prototype.greenFrom = undefined;

  /**
   * @member {Number} greenTo
   */
  exports.prototype.greenTo = undefined;

  /**
   * @member {module:model/Axis} hAxis
   */
  exports.prototype.hAxis = undefined;

  /**
   * @member {module:model/Axis} haxis
   */
  exports.prototype.haxis = undefined;

  /**
   * @member {Number} headerHeight
   */
  exports.prototype.headerHeight = undefined;

  /**
   * @member {Number} height
   */
  exports.prototype.height = undefined;

  /**
   * @member {String} id
   */
  exports.prototype.id = undefined;

  /**
   * @member {Boolean} is3D
   */
  exports.prototype.is3D = undefined;

  /**
   * @member {Boolean} isStacked
   */
  exports.prototype.isStacked = undefined;

  /**
   * @member {Date} lastUpdatedDateTime
   */
  exports.prototype.lastUpdatedDateTime = undefined;

  /**
   * @member {String} legend
   */
  exports.prototype.legend = undefined;

  /**
   * @member {String} maxColor
   */
  exports.prototype.maxColor = undefined;

  /**
   * @member {String} midColor
   */
  exports.prototype.midColor = undefined;

  /**
   * @member {String} minColor
   */
  exports.prototype.minColor = undefined;

  /**
   * @member {Number} minorTricks
   */
  exports.prototype.minorTricks = undefined;

  /**
   * @member {String} name
   */
  exports.prototype.name = undefined;

  /**
   * @member {Number} pieHole
   */
  exports.prototype.pieHole = undefined;

  /**
   * @member {Number} redFrom
   */
  exports.prototype.redFrom = undefined;

  /**
   * @member {Number} redTo
   */
  exports.prototype.redTo = undefined;

  /**
   * @member {Boolean} showInfoWindow
   */
  exports.prototype.showInfoWindow = undefined;

  /**
   * @member {Boolean} showScale
   */
  exports.prototype.showScale = undefined;

  /**
   * @member {Boolean} showTooltip
   */
  exports.prototype.showTooltip = undefined;

  /**
   * @member {String} title
   */
  exports.prototype.title = undefined;

  /**
   * @member {String} userId
   */
  exports.prototype.userId = undefined;

  /**
   * @member {module:model/Axis} vAxis
   */
  exports.prototype.vAxis = undefined;

  /**
   * @member {module:model/Axis} vaxis
   */
  exports.prototype.vaxis = undefined;

  /**
   * @member {Number} width
   */
  exports.prototype.width = undefined;

  /**
   * @member {String} wordtreeFormat
   */
  exports.prototype.wordtreeFormat = undefined;

  /**
   * @member {String} wordtreeWord
   */
  exports.prototype.wordtreeWord = undefined;

  /**
   * @member {Number} yellowFrom
   */
  exports.prototype.yellowFrom = undefined;

  /**
   * @member {Number} yellowTo
   */
  exports.prototype.yellowTo = undefined;

  return exports;

}));



// WEBPACK FOOTER //
// ./clientLibsDevelopment/src/model/GoogleChartOptionsRequest.js